import useLocalStorage from './useLocalStorage'
import useAccess from './access'

export default function useMerchant() {
  const { mandates, sms, user } = useLocalStorage()
  const { isDirection } = useAccess()
  const merchantSmsName = ref(null)

  const isEligibleForSmsUpsell = computed(() => {
    const hasValidMandate = mandates.value.find((mand) => mand.isActive === 1)
    const hasRightSmsPrice = sms.value.price === 9
    const hasDirectionRole = isDirection.value
    const hasRightCountryId = sms.value.countryId === 78
    return hasValidMandate && hasRightSmsPrice && hasRightCountryId && hasDirectionRole
  })

  merchantSmsName.value = user.value.merchant.smsName

  return {
    isEligibleForSmsUpsell,
    merchantSmsName
  }
}
